
<template>
    <section class="col-12">
        <label><strong>Client Contacts</strong></label>
        <div class="table table-responsive">
            <vue-good-table v-if="!loading"
                id="table-client_contacts"
                ref="table-client_contacts"
                :select-options="{ enabled: true, selectOnCheckboxOnly: true, }"
                :search-options="{ enabled: true,  placeholder:'Filter'}"
                @on-selected-rows-change="selectionChanged"
                :columns="columns"
                :rows="rows">
                <div slot="table-actions">
                    <div class="btn-group">
                        <button v-if="actionsLocal.add" type="button" title="Find" data-toggle="modal"
                                data-target="#clientContactsModal"
                                data-backdrop="static"
                                data-keyboard="false" class="btn btn-info" style="font-size: 12px;"><i
                            class="fa fa-search"></i> Search
                        </button>
                        <button v-if="actionsLocal.remove" type="button" @click="removeClientContact"
                                class="btn  btn-danger"
                                title="Delete"
                                style="font-size: 12px;"><i class="fa fa-trash"></i> Delete
                        </button>
                        <button v-if="actionsLocal.reset" type="button" @click="removeColumnsStore"
                                class="btn  btn-warning" title="Reset"
                                style="font-size: 12px;"><i class="fa fa-undo"></i> Reset
                        </button>

                        <button v-if="actionsLocal.columns" type="button" data-toggle="modal"
                                data-target="#columnsClientContactModal" data-backdrop="static"
                                title="Customize View"
                                data-keyboard="false" class="btn btn-secondary" style="font-size: 12px;"><i
                            class="fa fa-list"></i> Custom
                        </button>
                    </div>
                </div>
                <template slot="table-row" slot-scope="props">
                   <span v-if="props.column.field === 'custom_field'">
                       <span v-if="customField === 'Contract Type'">
                               <input type="hidden" :name="'contract_types['+props.row.id+'][site_id]'"
                                      :value="props.row.id">
                           <select :name="'contract_types['+props.row.id+'][contract_type_number]'"
                                   class="form-control">
                                    <option
                                        v-for="(contractType, ctIndex) in $store.getters['contract/getInstallments']"
                                        :selected="$store.getters['contract/checkContractTypeNumber'](props.row.id, ctIndex+1)"
                                        :value="ctIndex + 1">{{ ctIndex + 1 }}
                                    </option>
                           </select>
                            </span>
                   </span>
                    <span v-else-if="props.column.field === 'actions'">
                       <slot name="actions" :props="props" :columns="columns"></slot>
                   </span>
                    <span v-else-if="props.column.field === 'designation'" :title="props.formattedRow[props.column.field]">
                       {{ props.formattedRow[props.column.field].substring(0, 10) }}...
                   </span>
                    <span v-else> {{ props.formattedRow[props.column.field] }}</span>
                </template>
            </vue-good-table>
            <!-- Modal -->
            <div class="modal fade" id="clientContactsModal" tabindex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Find Client Contact</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" style="max-height: 400px; overflow-y: scroll;">
                            <generic-select @selecteds="setSelecteds"
                                            model="App\Models\ClientContact"></generic-select>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary" @click="addClientContact">Done</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="columnsClientContactModal" tabindex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Columns - Show/Hide</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" style="max-height: 400px; overflow-y: scroll;">
                            <div class="row">
                                <div v-for="(column, index) in columns" :key="index" class="col-md-4"
                                     style="border-bottom: 1px solid #DDDDDD">
                                    <a href="#" @click.prevent="setStatusColumn(column)" class="small"
                                       tabIndex="-1">
                                        <span v-if="column.hidden" class="fa fa-eye-slash"></span>
                                        <span v-else class="fa fa-eye text-info"></span>
                                        &nbsp;{{ column.label }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <input v-for="row in rows" type="hidden" :name="name+'[]'" :key="row.id" :value="row.id">
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import {URL_BASE} from "../../../utils/helper";
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import exportFromJSON from 'export-from-json'

export default {
    name: "ClientContacts",
    props: {
        clientContacts: {
            type: Array,
            default: []
        },
        name: {
            type: String,
            default: 'client_contacts',
            required: false
        },
        actions: {
            type: Object,
            default: null,
            required: false
        },
        customField: {
            type: String,
            default: null,
            required: false
        },
        order: {
            type: String,
            default: 'default',
        },
        customFieldPosition: {
            type: String,
            default: 'start',
        },
        extraId: {
            default: null,
        },
        trCondition: {
            type: Function,
            default: null,
        },
    },

    components: {
        VueGoodTable,
    },
    data() {
        return {
            actionsLocal: {
                add: true,
                edit: true,
                reset: true,
                remove: true,
                columns: true,
                file: true,
            },
            columns: [],
            rows: [],
            ids: [],
            selecteds: [],
            billin_account_id: null,
            client_contacts_selecteds: [],
            loading:true,
        };
    },
    mounted() {
        this.ids = this.clientContacts;
        this.getClientContacts()
        if (this.actions !== null) {
            this.actionsLocal = Object.assign(this.actionsLocal, this.actions);
        }
    },
    methods: {
        tdClassFunc(row) {
            return this.trCondition(row);
        },
        toggleColumn(index, event) {
            this.$set(this.columns[index], 'hidden', !this.columns[index].hidden);
        },
        setStatusColumn(column) {
            column.hidden = !column.hidden;
            this.setColumnsStore()
        },
        async getClientContacts() {
            let app = this;
            let ids = this.ids.map(function (el, index) {
                return `ids[${index}]=${el}`
            }).join('&');
            await axios.get(`/client_contacts/list-of-ids?${ids}&order=${this.order}`).then((response) => {
                app.columns = response.data.columns
                if (app.trCondition != null) {
                    app.columns = app.columns.map((e) => {
                        e.tdClass = app.tdClassFunc
                        return e;
                    })
                }
                app.rows = response.data.rows
                app.getColumnsStore()

                app.loading = false

            })
                .catch((err) => {
                    showMessage('e', 'Error loading client_contacts');
                    console.error(err);
                })

            this.$root.addTypeButton();

        },
        setSelecteds(client_contacts) {
            this.client_contacts_selecteds = client_contacts;
        },
        addClientContact() {
            this.ids = this.rows.map(function (el) {
                return el.id;
            })
            if (this.client_contacts_selecteds.length) {
                for (let i = 0; i < this.client_contacts_selecteds.length; i++) {
                    this.ids.push(this.client_contacts_selecteds[i]);
                }
            }
            this.client_contacts_selecteds = []
            this.getClientContacts()
            $('#clientContactsModal').modal('toggle');
        },
        addClientContactId(id) {
            this.billin_account_id = id
        },
        removeClientContact() {
            let app = this;
            this.rows = this.rows.filter(function (item) {
                let deleted = false;
                for (let i = 0; i < app.selecteds.length; i++) {
                    if (app.selecteds[i].id === item.id) {
                        deleted = true;
                        break;
                    }
                }
                return !deleted
            })
        },
        selectionChanged(params) {
            // params.selectedRows - all rows that are selected (this page)
            this.selecteds = params.selectedRows
        },
        setColumnsStore() {
            localStorage.removeItem('client_contact_columns');
            let columns = this.columns.filter((col) => {
                return !col.hidden
            });
            localStorage.setItem('client_contact_columns', JSON.stringify(columns));
        },
        getColumnsStore() {
            let columns = localStorage.getItem('client_contact_columns');
            if (columns) {
                columns = JSON.parse(columns)
                this.columns = this.columns.map((col) => {
                    col.hidden = true;
                    for (let i = 0; i < columns.length; i++) {
                        if (columns[i].field === col.field) {
                            col.hidden = false;
                            break;
                        }
                    }
                    return col
                });

            }

            if (this.customField != null) {
                if (this.customFieldPosition === 'start')
                    this.columns.unshift({label: this.customField, field: 'custom_field',});
                else {
                    let lenghtColumn = this.columns.length - 1;
                    if (this.columns[lenghtColumn].field === 'actions') {
                        let lastColumn = this.columns[lenghtColumn];
                        this.columns[lenghtColumn] = {label: this.customField, field: 'custom_field'}
                        this.columns.push(lastColumn);
                    } else {
                        this.columns.push({label: this.customField, field: 'custom_field',});
                    }
                }
            }
        },
        removeColumnsStore() {
            localStorage.removeItem('client_contact_columns');
            this.getClientContacts()
        },
        exportExcel() {

            let data = [];
            let header = [];
            header = this.columns.filter((col) => {
                return !col.hidden;
            })

            data.push(header.map((h) => {
                return h.label
            }))

            let fields = header.map((_) => {
                return _.field;
            })

            this.rows.forEach((row) => {
                let r = [];
                for (let i = 0; i < fields.length; i++) {
                    r.push(row[fields[i]])
                }
                data.push(r)
            })

            const fileName = 'client_contacts'
            const exportType = exportFromJSON.types.xls

            exportFromJSON({data, fileName, exportType})
        },

    }
}
</script>

<style>
.vgt-table td, .vgt-table th {
    padding: 2px !important;
    font-size: 12px;
}

#vgt-table {
    min-height: 100px;
}
</style>
